import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from '@/img/close.svg';
const _hoisted_1 = { class: "opModal" };
const _hoisted_2 = { class: "d-flex justify-content-between" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "text-red" }, " Ricerca immobili ", -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("img", { src: _imports_0 }, null, -1);
const _hoisted_5 = [
    _hoisted_4
];
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "col-md-6" };
const _hoisted_8 = { class: "row" };
const _hoisted_9 = { class: "col-md-6" };
const _hoisted_10 = { class: "form-group" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("label", null, "Città", -1);
const _hoisted_12 = { class: "form-group" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("label", null, "Centro di costo", -1);
const _hoisted_14 = { class: "form-group" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("label", null, "Numero immobile", -1);
const _hoisted_16 = { class: "form-group" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("label", null, "Indirizzo", -1);
const _hoisted_18 = { class: "col-md-6" };
const _hoisted_19 = { class: "form-group" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("label", null, "Zona", -1);
const _hoisted_21 = { class: "form-group" };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("label", null, "Asset class", -1);
const _hoisted_23 = ["value"];
const _hoisted_24 = { class: "form-group" };
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("label", null, "Superficie commerciale min", -1);
const _hoisted_26 = { class: "form-group" };
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("label", null, "Superficie commerciale max", -1);
const _hoisted_28 = { class: "col-sm-6" };
const _hoisted_29 = { class: "form-group" };
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("label", null, "Creato dal", -1);
const _hoisted_31 = { class: "col-sm-6" };
const _hoisted_32 = { class: "form-group" };
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("label", null, "Creato al", -1);
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1);
const _hoisted_35 = { class: "d-flex align-items-center mb-3" };
const _hoisted_36 = { class: "max-h-400" };
const _hoisted_37 = { class: "table" };
const _hoisted_38 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("td", null, "Data creazione"),
        /*#__PURE__*/ _createElementVNode("td", null, "Città"),
        /*#__PURE__*/ _createElementVNode("td", null, "Centro di costo"),
        /*#__PURE__*/ _createElementVNode("td", null, "Numero immobile"),
        /*#__PURE__*/ _createElementVNode("td", null, "Indirizzo"),
        /*#__PURE__*/ _createElementVNode("td", null, "Zona"),
        /*#__PURE__*/ _createElementVNode("td", null, "Asset class"),
        /*#__PURE__*/ _createElementVNode("td", null, "Superficie commerciale")
    ])
], -1);
const _hoisted_39 = { key: 0 };
const _hoisted_40 = ["onClick"];
const _hoisted_41 = { class: "d-flex justify-content-center mt-2" };
const _hoisted_42 = ["disabled"];
const _hoisted_43 = ["onClick"];
const _hoisted_44 = {
    type: "button",
    class: "btn btn-sm btn-link selected"
};
const _hoisted_45 = ["onClick"];
const _hoisted_46 = ["disabled"];
const _hoisted_47 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1);
const _hoisted_48 = /*#__PURE__*/ _createElementVNode("div", { class: "text-red" }, " Seleziona il periodo ", -1);
const _hoisted_49 = { class: "row" };
const _hoisted_50 = { class: "col-sm-6" };
const _hoisted_51 = { class: "form-group" };
const _hoisted_52 = /*#__PURE__*/ _createElementVNode("label", null, "Data inizio", -1);
const _hoisted_53 = { class: "col-sm-6" };
const _hoisted_54 = { class: "form-group" };
const _hoisted_55 = /*#__PURE__*/ _createElementVNode("label", null, "Data fine", -1);
const _hoisted_56 = { class: "text-end mt-4" };
const _hoisted_57 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_group_filter = _resolveComponent("group-filter");
    const _component_op_date = _resolveComponent("op-date");
    const _component_toggler = _resolveComponent("toggler");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("button", {
                class: "btn",
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close')))
            }, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_group_filter, {
                    modelValue: _ctx.groupFilter,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.groupFilter) = $event))
                }, null, 8, ["modelValue"])
            ])
        ]),
        _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.search.citta) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.search.citta]
                    ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.search.centroDiCosto) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.search.centroDiCosto]
                    ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.search.numeroImmobile) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.search.numeroImmobile]
                    ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.search.indirizzo) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.search.indirizzo]
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.search.zona) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.search.zona]
                    ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _withDirectives(_createElementVNode("select", {
                        class: "form-control",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.search.assetClass) = $event))
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assetClassOptions, (item, i) => {
                            return (_openBlock(), _createElementBlock("option", {
                                value: item.key
                            }, _toDisplayString(item.value), 9, _hoisted_23));
                        }), 256))
                    ], 512), [
                        [_vModelSelect, _ctx.search.assetClass]
                    ]),
                    (_ctx.search.assetClass)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "ms-2 btn btn-sm btn-danger",
                            onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.search.assetClass = ''))
                        }, "x"))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.search.superficieCommercialeMin) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.search.superficieCommercialeMin]
                    ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.search.superficieCommercialeMax) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.search.superficieCommercialeMax]
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createVNode(_component_op_date, {
                        class: "form-control",
                        modelValue: _ctx.search.createdFrom,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.search.createdFrom) = $event))
                    }, null, 8, ["modelValue"])
                ])
            ]),
            _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createVNode(_component_op_date, {
                        class: "form-control",
                        modelValue: _ctx.search.createdTo,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.search.createdTo) = $event))
                    }, null, 8, ["modelValue"])
                ])
            ])
        ]),
        _hoisted_34,
        _createElementVNode("div", _hoisted_35, [
            _createVNode(_component_toggler, {
                class: "me-1",
                modelValue: _ctx.isSelectAll,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.isSelectAll) = $event))
            }, null, 8, ["modelValue"]),
            _createTextVNode(" Seleziona tutta la tabella ")
        ]),
        _createElementVNode("div", {
            class: _normalizeClass({ 'opacity-25': _ctx.isSelectAll })
        }, [
            _createElementVNode("div", _hoisted_36, [
                _createElementVNode("table", _hoisted_37, [
                    _hoisted_38,
                    _createElementVNode("tbody", null, [
                        (_ctx.list.data.length == 0)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_39, " Nessuna riga da mostrare "))
                            : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list.data, (item, i) => {
                            return (_openBlock(), _createElementBlock("tr", {
                                class: _normalizeClass(["pointer", { active: _ctx.isSelected(item) }]),
                                key: item.id,
                                onClick: ($event) => (_ctx.toggleSelection(item))
                            }, [
                                _createElementVNode("td", null, _toDisplayString(item.createdOn), 1),
                                _createElementVNode("td", null, _toDisplayString(item.citta), 1),
                                _createElementVNode("td", null, _toDisplayString(item.centroDiCosto), 1),
                                _createElementVNode("td", null, _toDisplayString(item.numeroImmobile), 1),
                                _createElementVNode("td", null, _toDisplayString(item.indirizzo), 1),
                                _createElementVNode("td", null, _toDisplayString(item.zona), 1),
                                _createElementVNode("td", null, _toDisplayString(item.assetClass), 1),
                                _createElementVNode("td", null, _toDisplayString(item.superficieCommerciale), 1)
                            ], 10, _hoisted_40));
                        }), 128))
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_41, [
                _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-link me-2",
                    disabled: _ctx.page == 1,
                    onClick: _cache[14] || (_cache[14] =
                        //@ts-ignore
                        (...args) => (_ctx.prev && _ctx.prev(...args)))
                }, "Prec.", 8, _hoisted_42),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prevPages, (p) => {
                    return (_openBlock(), _createElementBlock("button", {
                        type: "button",
                        class: "btn btn-sm btn-link me-2",
                        onClick: ($event) => (_ctx.setPage(p))
                    }, _toDisplayString(p), 9, _hoisted_43));
                }), 256)),
                _createElementVNode("button", _hoisted_44, _toDisplayString(_ctx.page), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nextPages, (p) => {
                    return (_openBlock(), _createElementBlock("button", {
                        type: "button",
                        class: "btn btn-sm btn-link ms-2",
                        onClick: ($event) => (_ctx.setPage(p))
                    }, _toDisplayString(p), 9, _hoisted_45));
                }), 256)),
                _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-link ms-2",
                    disabled: _ctx.totalPages <= _ctx.page,
                    onClick: _cache[15] || (_cache[15] =
                        //@ts-ignore
                        (...args) => (_ctx.next && _ctx.next(...args)))
                }, "Succ.", 8, _hoisted_46)
            ])
        ], 2),
        _hoisted_47,
        _hoisted_48,
        _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                    _hoisted_52,
                    _createVNode(_component_op_date, {
                        class: "form-control",
                        modelValue: _ctx.startDate,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.startDate) = $event))
                    }, null, 8, ["modelValue"])
                ])
            ]),
            _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                    _hoisted_55,
                    _createVNode(_component_op_date, {
                        class: "form-control",
                        modelValue: _ctx.endDate,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_ctx.endDate) = $event))
                    }, null, 8, ["modelValue"])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_56, [
            _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                disabled: !_ctx.canNext,
                onClick: _cache[18] || (_cache[18] = ($event) => (_ctx.ok()))
            }, "Seleziona", 8, _hoisted_57)
        ])
    ]));
}
